import {LOCALE_ID, NgModule} from '@angular/core';
import { BrowserModule } from '@angular/platform-browser';

import { AppRoutingModule } from './app-routing.module';
import { AppComponent } from './app.component';
import { VerifyInformationComponent } from './modules/private/verify-information/verify-information/verify-information.component';
import { VerifyListDocumentsComponent } from './modules/private/verify-information/screens/verify-information-list-documents/verify-list-documents.component';
import { OffersComponent } from './modules/private/verify-information/screens/verify-information-offers/offers.component';
import { SingleDocumentComponent } from './modules/private/verify-information/screens/verify-information-single-document/single-document.component';
import { VerifyInformationFormComponent } from './modules/private/verify-information/screens/verify-information-form/verify-information-form.component';
import { VerifyInformationDetailStepComponent } from './modules/private/verify-information/screens/verify-information-detail-step/verify-information-detail-step.component';
import { VerifyInformationExternalLinkComponent } from './modules/private/verify-information/screens/verify-information-external-link/verify-information-external-link.component';
import {ButtonModule} from "primeng/button";
import { AccordionModule } from 'primeng/accordion';
import {SharedModule} from "./shared/shared.module";
import { SkeletonBottomMenuComponent } from './skeleton/skeleton-bottom-menu/skeleton-bottom-menu.component';
import { SkeletonLeftMenuComponent } from './skeleton/skeleton-left-menu/skeleton-left-menu.component';
import {FontAwesomeModule} from "@fortawesome/angular-fontawesome";

import localEs from '@angular/common/locales/es'
import localEsMX from '@angular/common/locales/es-MX'
import {registerLocaleData} from "@angular/common";
import {CardModule} from "primeng/card";
import { ProgressVerificationComponent } from './modules/private/verify-information/components/progress-verification/progress-verification.component';
import { VerificationDocumentsListComponent } from './modules/private/verify-information/components/verification-documents-list/verification-documents-list.component';
import {CoreModule} from "./core/core.module";
import {MessageModule} from "primeng/message";
import { FormComponentComponent } from './modules/private/verify-information/components/form-component/form-component.component';
import { DocumentComponentComponent } from './modules/private/verify-information/components/document-component/document-component.component';
import { CamaraGuiaComponent } from './modules/private/verify-information/components/camara-guia/camara-guia.component';
import { ExternalComponentComponent } from './modules/private/verify-information/components/external-component/external-component.component';
import { IneValidationComponent } from './modules/private/verify-information/components/ine-validation/ine-validation.component';
import { SignDocumentComponent } from './modules/private/verify-information/components/sign-document/sign-document.component';
import { OfferComponentComponent } from './modules/private/verify-information/components/offer-component/offer-component.component';
import { ManualValidationComponentComponent } from './modules/private/verify-information/components/manual-validation-component/manual-validation-component.component';
import { AccountValidationComponentComponent } from './modules/private/verify-information/components/account-validation-component/account-validation-component.component';
import { VideoselfieComponentComponent } from './modules/private/verify-information/components/videoselfie-component/videoselfie-component.component';
import {ChipModule} from "primeng/chip";

registerLocaleData(localEsMX, 'es')
@NgModule({
  declarations: [
    AppComponent,
    VerifyInformationComponent,
    VerifyListDocumentsComponent,
    OffersComponent,
    SingleDocumentComponent,
    VerifyInformationFormComponent,
    VerifyInformationDetailStepComponent,
    VerifyInformationExternalLinkComponent,
    SkeletonBottomMenuComponent,
    SkeletonLeftMenuComponent,
    ProgressVerificationComponent,
    VerificationDocumentsListComponent,
    FormComponentComponent,
    DocumentComponentComponent,
    CamaraGuiaComponent,
    ExternalComponentComponent,
    IneValidationComponent,
    SignDocumentComponent,
    OfferComponentComponent,
    ManualValidationComponentComponent,
    AccountValidationComponentComponent,
    VideoselfieComponentComponent
  ],
  imports: [
    CoreModule,
    BrowserModule,
    AppRoutingModule,
    ButtonModule,
    SharedModule,
    FontAwesomeModule,
    CardModule,
    AccordionModule,
    ChipModule
  ],
  providers: [{provide: LOCALE_ID, useValue: 'es-MX'}],
  bootstrap: [AppComponent]
})
export class AppModule { }
